import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/organisms/footers/Footer.tsx");
